import { useKioskIntegration } from '../../hooks/useKioskIntegration';
import { UrlUtility } from '../../util/aactools/urlUtility';
import platform from '../../util/platform';

const urlUtility = new UrlUtility();

const getApplications = () => {
  const appInfo = urlUtility.getAppInfo().seriesGallery?.applications;
  return appInfo;
};

const severalApplicationsExist = () => {
  return getApplications().length > 1;
};

const shouldShowOpenSeriesGalleryButton = () => {
  const { isUpptackaOrIpexGallery } = useKioskIntegration();
  return (
    (isUpptackaOrIpexGallery || severalApplicationsExist()) && platform.isKiosk
  );
};

export default shouldShowOpenSeriesGalleryButton;
